import { CSSProperties, ReactNode, forwardRef } from 'react';
import { css, cx } from '@linaria/atomic';
import { motion } from 'motion/react';
import { theme } from '@frontend/theme';
import { WIDTH_DIMS } from '@frontend/design-system';

interface Props {
  children: ReactNode;
  className?: string;
  width?: keyof typeof WIDTH_DIMS;
}

export const AsidePanel = forwardRef<HTMLDivElement, Props>(
  ({ width = 'small', children, className, ...rest }, ref) => {
    const cssVars = { '--aside-width': `${WIDTH_DIMS[width]}px` } as CSSProperties;

    return (
      <motion.aside
        ref={ref}
        layout
        initial={{ width: 0, opacity: 0 }}
        animate={{ width: WIDTH_DIMS[width], opacity: 1 }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
        exit={{ width: 0, opacity: 0 }}
        className={cx(asideStyle, className)}
        style={cssVars}
        {...rest}
      >
        <motion.section className={sectionStyle}>{children}</motion.section>
      </motion.aside>
    );
  }
);

const asideStyle = css`
  height: 100%;
  display: flex;
  width: var(--aside-width);
  border-left: 1px solid ${theme.colors.neutral20};
  border-top: 1px solid ${theme.colors.neutral20};
  position: relative;
`;

const sectionStyle = css`
  min-width: var(--aside-width);
  overflow: hidden auto;
`;
